import axios from './axios';

export enum VerificationStatus {
    None = "none",
    Submitted = "submitted",
    AgreementRequested = "agreementRequested",
    Rejected = "rejected",
    Verified = "verified"
}

export interface MeVerification {
    rejectedReason?: string;
    verificationStatus: VerificationStatus;
}

export interface MeResponse {
    username: string;
    email: string;
    name: string;
    description: string;
    site: string;
    verification: MeVerification;
    avatar: string;
    
}
export const getMe = () => {
    return axios.get<MeResponse>('/me');
}

export interface SetProfileRequest {
    name?: string;
    description?: string;
    site?: string;
}

export const setProfile = (body: SetProfileRequest) => {
    return axios.post<MeResponse>('/me/edit/profile', body);
}

export const setAvatar = (formData: FormData) => {
    return axios.post<MeResponse>('/me/edit/avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    });
}

export const verify = (formData: FormData) => {
    return axios.post<MeResponse>('/me/verify', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    });
}